/* istanbul ignore file */
import React from 'react';
import SingleAccountBreadcrumbs from 'domain/sales/account/shared/SingleAccountBreadcrumbs';
import { BreadcrumbItem } from 'framework/ui/BreadCrumbs';

const AccountRelatedOpportunitiesBreadcrumbs = () => {
  return (
    <SingleAccountBreadcrumbs>
      <BreadcrumbItem>Related Opportunities</BreadcrumbItem>
    </SingleAccountBreadcrumbs>
  );
};

export default AccountRelatedOpportunitiesBreadcrumbs;
